export type WorkspaceArea = "library" | "ingestion" | "suggestion" | "feed_import" | "org_settings";

/**
 * Cross-mode navigation intent passed to `AdsAssistantPanel`. The
 * `expandActivityStrip` field was retired in Phase 6 (see
 * `docs/planning/org_activity_top_level_mode.md`) — activity now lives in
 * its own primary mode.
 */
export type AdsAssistantPanelIntent = {
  area: WorkspaceArea;
} | null;

/** @deprecated Use AdsAssistantPanelIntent */
export type WorkspaceAreaIntent = AdsAssistantPanelIntent;

export function shortOrgId(id: string | null): string {
  if (!id) return "—";
  if (id.length <= 12) return id;
  return `${id.slice(0, 8)}…${id.slice(-4)}`;
}
